import FederatedIdentitiesService from '../../../services/federated_identities';
import usersApi from '../../../services/users';

export const initiatePasswordReset = async (
  isStaffRequest: boolean,
  userId: string,
  email: string
) => {
  let notificationType;
  let notificationMessage;
  const resetPassword = isStaffRequest
    ? FederatedIdentitiesService.postStaffResetPassword
    : FederatedIdentitiesService.postResetPassword;
  await resetPassword({
    userId,
    email,
  })
    .then((res) => {
      if (res.ok) {
        notificationType = 'success';
        notificationMessage = `Password reset link has been sent to ${email}.`;
      } else {
        throw new Error('status is not 2xx');
      }
    })
    .catch(() => {
      notificationType = 'danger';
      notificationMessage = isStaffRequest
        ? `User ${userId} password could not be reset. Wait a few minutes and try again.`
        : 'Account password could not be reset. Wait a few minutes and try again.';
    });
  return { notificationType, notificationMessage };
};

export const initiateResendEmailVerification = async (
  userId: string,
  email: string
) => {
  let notificationType;
  let notificationMessage;
  await FederatedIdentitiesService.postResendVerificationEmail(userId)
    .then((res) => {
      if (res.ok) {
        notificationType = 'success';
        notificationMessage = `The verification email was sent. Follow the instructions sent to ${email} to verify your email.`;
      } else {
        throw new Error('status is not 2xx');
      }
    })
    .catch(() => {
      notificationType = 'danger';
      notificationMessage =
        'The email verification link could not be sent. Wait a few minutes and try again.';
    });
  return { notificationType, notificationMessage };
};

export const notHandledButtonClick = async (buttonClicked: string) => {
  const notHandledButtonType = {
    notificationType: 'danger',
    notificationMessage:
      'The link could not be sent. Wait a few minutes and try again.',
  };
  console.error(
    `Error: Unhandled Button Click: ${buttonClicked}`,
    notHandledButtonType
  );
  return notHandledButtonType;
};

export const addMfaMethod = async (userId, mfa_method) => {
  let notificationType;
  let notificationMessage;
  let error = false;
  let resendVerificationEmail = false;

  try {
    const res = await usersApi.postMfaMethod(userId, { mfa_method });
    if (res.status === 200) {
      notificationType = 'success';
      notificationMessage =
        'You have activated MFA on this account. A verification code will be emailed to you every time you sign in.';
    } else {
      throw new Error('status is not 2xx');
    }
  } catch (err) {
    error = true;
    if (err.response && err.response.status === 400) {
      resendVerificationEmail = true;
      notificationType = 'danger';
      notificationMessage = `
        To activate MFA, please verify your email address first. Check your inbox for a verification email and follow the instructions. Once verified, return here to enable MFA
      `;
    } else {
      error = true;
      notificationType = 'danger';
      notificationMessage =
        'We encountered an unexpected error while calling the API server. Please try again in 5 minutes.';
    }
  }

  return {
    notificationType,
    notificationMessage,
    error,
    resendVerificationEmail,
  };
};

export const deleteMfaMethod = async (userId) => {
  let notificationType;
  let notificationMessage;
  let error = false;

  try {
    const res = await usersApi.deleteMfaMethod(userId);

    if (res.status === 200) {
      notificationType = 'success';
      notificationMessage =
        'You have deactivated MFA on this account. You can reactivate MFA anytime from this page.';
    } else {
      throw new Error('status is not 2xx');
    }
  } catch (err) {
    error = true;
    notificationType = 'danger';
    notificationMessage =
      'We encountered an unexpected error while calling the API server. Please try again in 5 minutes.';
  }

  return { notificationType, notificationMessage, error };
};
